// Port of api/fuel/app/classes/filter/search/games/rules/query/worth.php
import Rule from 'offline/filter/core/search/rule'
import F from 'offline/filter/constants'

export default Rule.create({
	name: 'worth',
	field: function() {
		// In collection context, use collection_value; otherwise game_worth_value
		if (this._config && this._config.cacheType === F.CACHE_COLLECTION) {
			return 'COALESCE(c.collection_value, 0)'
		}
		return 'COALESCE(g.game_worth_value, 0)'
	}
})
